"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.StyledHeadingMobile = exports.StyledHeadingDesktop = exports.StyledCloudinaryPicture = exports.ResultRow = exports.ContentWrapper = exports.Chevron = void 0;
var _styledComponents = _interopRequireDefault(require("styled-components"));
var _partials = require("../../styles/partials");
var _vars = require("../../styles/vars");
var _CloudinaryPicture = _interopRequireDefault(require("../CloudinaryPicture"));
var _Heading = require("../Heading");
var _Icon = _interopRequireDefault(require("../Icon"));
function _interopRequireDefault(e) { return e && e.__esModule ? e : { "default": e }; }
//helpers

//components

var ResultRow = exports.ResultRow = _styledComponents["default"].a.attrs({
  'data-cy': 'result-card'
}).withConfig({
  displayName: "styles__ResultRow",
  componentId: "sc-1k0zjhx-0"
})(["align-items:center;background:#fff;display:flex;padding:0.5rem;text-decoration:none;", ""], function (p) {
  return p.device === 'desktop' && "\n    ".concat((0, _vars.cardShadowCss)(p.shouldShowShadowOnHover), "\n    border-radius: ").concat(_vars.borderRadius.desktop, "px;\n  ");
});
var StyledCloudinaryPicture = exports.StyledCloudinaryPicture = (0, _styledComponents["default"])(_CloudinaryPicture["default"]).attrs({
  aspectRatio: 4 / 3,
  sizes: '84px'
}).withConfig({
  displayName: "styles__StyledCloudinaryPicture",
  componentId: "sc-1k0zjhx-1"
})(["flex-shrink:0;width:84px;"]);
var StyledHeadingDesktop = exports.StyledHeadingDesktop = (0, _styledComponents["default"])(_Heading.HeadingDesktop).withConfig({
  displayName: "styles__StyledHeadingDesktop",
  componentId: "sc-1k0zjhx-2"
})(["display:flex;white-space:nowrap;> b{", ";margin-right:0.3em;}"], _partials.truncate);
var StyledHeadingMobile = exports.StyledHeadingMobile = StyledHeadingDesktop.withComponent(_Heading.HeadingMobile);
var ContentWrapper = exports.ContentWrapper = _styledComponents["default"].div.withConfig({
  displayName: "styles__ContentWrapper",
  componentId: "sc-1k0zjhx-3"
})(["flex-grow:1;margin:0 1rem;overflow:hidden;"]);
var Chevron = exports.Chevron = (0, _styledComponents["default"])(_Icon["default"]).attrs({
  name: 'chevron-right'
}).withConfig({
  displayName: "styles__Chevron",
  componentId: "sc-1k0zjhx-4"
})(["display:block;flex-shrink:0;margin-left:1rem;opacity:0.2;"]);
//# sourceMappingURL=styles.js.map